import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import MapFigure from '../map-data/map-figure';

const LinkedElementFigure = () => {
  const linkedElement = useSelector(state => state.map.linkedElement);
  const linkedElementActive = useSelector(state => state.map.linkedElementActive);

  if (!linkedElementActive || !linkedElement || !linkedElement.data) {
    return null;
  }

  const {layerData, data} = linkedElement;
  const mapStyle = (layerData && layerData.mapStyle) || {};
  const uiStyle = (layerData && layerData.uiStyle) || {};

  return (
    <MapFigure
      mapElement={data}
      layerId={layerData && layerData.id}
      mapStyle={mapStyle}
      activeMarker={uiStyle.activeMarker || uiStyle.marker}
      marker={uiStyle.marker}
      highlightable={Boolean(uiStyle.highlightable)}
      selected
    />
  );
};

export default memo(LinkedElementFigure);
